<!--支付成功-->
<template>
  <div class="paySuccess-container">
    <headerIndex/>
    <div class="paySuccess-content" :style="'min-height:'+min_height+'px;'">
      <div class="pay-status">
        <el-container>
          <el-aside width="">
            <div class="left-div">
              <p class="success-title SourceHanSansCN">支付成功</p>
              <p class="price">{{ parseFloat(orderInfo.total) }}元</p>
              <div class="sussess-btn">
                <el-button type="danger" plain style="width: 65%" @click="orderDetails">查看订单详情</el-button>
              </div>
              <div class="tips">
                <p>我们不会以任何理由要求您提供银行卡信息或支付额外费用</p>
                <p>请谨防钓鱼链接和诈骗电话</p>
              </div>
            </div>
          </el-aside>
          <el-main style="padding: 50px 40px 0px;">
            <el-descriptions :column="1">
              <el-descriptions-item label="订单编号">{{ orderInfo.orderNum }}</el-descriptions-item>
              <el-descriptions-item label="收货信息">
                <p class="descriptions-p">{{ orderInfo.consigneeUser }} {{ parseStringToStar(orderInfo.consigneePhone) }}</p>
                <p class="descriptions-p">{{ orderInfo.payAddress }}</p>
              </el-descriptions-item>
              <el-descriptions-item label="商品名称">{{ orderInfo.goodsName }}</el-descriptions-item>
            </el-descriptions>
          </el-main>
        </el-container>
      </div>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {getMyOrderDetails} from "@/api/orderApi";

export default {
  name: "paySuccess",
  components: {headerIndex, home_footer, Hang},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 275,
      orderInfo: {},
      cid: 0,
    }
  },
  methods: {
    /*获取订单数据*/
    getOrderInfo() {
      getMyOrderDetails({order_id: this.$route.query.id, uid: this.cid, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.orderInfo = res.content.sselectMyOrderDetailsVo;
        }
      })
    },
    /*手机号处理*/
    parseStringToStar(str) {
      let start = str.slice(0, 3)
      let end = str.slice(-4)
      return `${start}****${end}`
    },
    /*查看订单详情*/
    orderDetails(){
      this.$router.push({
        path: "/orderManagement/orderDetails",
        query: {state:this.orderInfo.state,id:this.orderInfo.id},
      });
    }
  },
  mounted() {
    this.getOrderInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.paySuccess-container >>> .paySuccess-content .el-button--danger.is-plain {
  color: #FE273B;
  background: #ffffff;
  border-color: #FE273B;
}

.paySuccess-container >>> .paySuccess-content .el-button--danger.is-plain:hover {
  background: #fef0f0;
  border-color: #F56C6C;
  color: #FE273B;
}

.paySuccess-container >>> .paySuccess-content .el-descriptions-item__container .el-descriptions-item__content,
.paySuccess-container >>> .paySuccess-content .el-descriptions-item__container .el-descriptions-item__label {
  display: block;
}
.paySuccess-container >>> .paySuccess-content .el-descriptions-item__label.has-colon{
  color: #999999;
}
</style>
<style scoped lang="scss">
.paySuccess-container {
  background: #ffffff;

  .paySuccess-content {
    padding: 60px 18% 45px;

    .pay-status {
      box-shadow: 0px 0px 3px -1px #808080;

      .left-div {
        min-height: 560px;
        background: #F5F5F5;
        cursor: context-menu;
        min-width: 420px;

        .success-title {
          text-align: center;
          font-size: 36px;
          color: #333333;
          padding-top: 140px;
          margin-block-start: 0em;
          margin-block-end: 0px;
        }

        .price {
          font-size: 18px;
          color: #333333;
          text-align: center;
          margin-block-start: 0em;
          margin-block-end: 0px;
          padding-top: 20px;
        }

        .sussess-btn {
          display: flex;
          justify-content: center;
          padding-top: 50px;
        }

        .tips {
          margin-top: 155px;

          p {
            font-size: 14px;
            color: #666666;
            display: flex;
            justify-content: center;
            margin-block-start: 0px;
            margin-block-end: 0px;
            padding-bottom: 5px;
          }
        }
      }

      .descriptions-p {
        margin-block-start: 0em;
        margin-block-end: 0px;
        cursor: context-menu;
        padding-bottom: 5px;
      }
    }
  }
}
</style>